module.exports = __webpack_public_path__ + "img/gszz6@2x.d2a1b214.png";